import { ModalContentStyled } from "../styled/ModalsStyled";
import ModalsCloseButton from "../components/ModalsCloseButton/ModalsCloseButton";
import { useCallback } from "react";
import { createStructuredSelector } from "reselect";
import { getAppUser } from "../../../app/appSelectors";
import { connect } from "react-redux";
import { appInitAction, closeModalAction } from "../../../app/appActions";
import ToAppButton from "../../../components/ToAppButton/ToAppButton";
import { isClientMobile } from "../../../components/ClientInfo/ClientInfo";
import EmailConfirmed from "../../Account/components/EmailConfirmed";

const ButtonWrapper = ({children}) => isClientMobile
    ? <ToAppButton>
        {children}
    </ToAppButton>
    : <>
        {children}
    </>;

function EmailConfirmedModal(props) {
    const {closeModalAction} = props;

    const handleButtonClick = useCallback(() => {
        if (!isClientMobile) {
            closeModalAction();
        }
    }, [closeModalAction])

    return <ModalContentStyled className="h-100 d-flex justify-content-center align-items-center flex-column w-100">
        <EmailConfirmed handleButtonClick={handleButtonClick} ButtonWrapperComponent={ButtonWrapper}/>
        <ModalsCloseButton/>
    </ModalContentStyled>
}

const mapStateToProps = createStructuredSelector({
    user: getAppUser,
});

const mapDispatchToProps = {
    appInitAction,
    closeModalAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailConfirmedModal);
